import { api } from './api'

// The D15 below-floor refusal: 409 with the seller's £ floor in the message.
// Warn-and-confirm, never warn-and-block — the seller contact happens outside
// the system, so every screen that writes a price must offer the confirmed
// retry. Keep ALL price-write callers on this helper: a caller that shows the
// 409 as a plain error strands the operator with no way to proceed
// (review H1, 2026-08-05 — Drafts Manager shipped exactly that).
export function isFloorRefusal(err) {
  return err?.status === 409 && /floor/i.test(err?.message || '')
}

/**
 * POST a price write; on the floor refusal, confirm with the operator and
 * retry once with `confirmBelowFloor`. Any other error — and a declined
 * confirm — rethrows for the caller's normal error handling.
 */
export async function postPriceWithFloorConfirm(url, body, confirmSuffix = 'Set the price anyway?') {
  try {
    return await api.post(url, body)
  } catch (err) {
    if (!isFloorRefusal(err)) throw err
    if (!window.confirm(`${err.message}\n\n${confirmSuffix}`)) throw err
    return api.post(url, { ...body, confirmBelowFloor: true })
  }
}
